import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import Button from 'react-bootstrap/Button';
import clsx from 'clsx';
import SVGComponent from '../SVGComponents/SVGComponents';
import { PaperComponent } from '../utilities/utilities';

function CommonModal(props) {
  const {
    open,
    onOk,
    okTitle,
    onClose,
    disableOk,
    closeTitle,
    modalTitle,
    className,
    viewAction,
    viewHeader,
    childrenComponent,
    removeClassName,
    dialogSpace,
    calculateTitle,
    isDisabledCalculate,
    onCalculate,
    customClassJustifycenter,
    autoFocus,
    onCancel,
    crossMarkClose,
    noTitle,
    onNo,
    disableNo,
  } = props;

  return (
    <Dialog
      open={open}
      className={clsx('multiGroupDialog custom-dialog-box', className)}
      data-testid="common-modal"
      aria-describedby="modal-description"
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <div style={{ cursor: 'move' }} id="draggable-dialog-title">
        {viewHeader && (
          <DialogTitle className="custom-panel p-0" id="modal-title">
            <div className="panel-header">
              <span className="float-left">{modalTitle}</span>
              {onClose && (
                <span
                  className="float-right"
                  data-testid="searchExcluded"
                  role="button"
                  onClick={
                    onCancel
                      ? onCancel
                      : crossMarkClose === 'Yes'
                      ? onOk
                      : onClose
                  }
                  aria-label="close"
                  tabIndex="0"
                >
                  <i className="fa fa-times-circle" aria-hidden="true" />
                </span>
              )}
              <div className="clearfix" />
            </div>
          </DialogTitle>
        )}
      </div>

      <DialogContent id="modal-description">
        <div
          className={
            dialogSpace ? 'custom-panel' : 'custom-panel frr-modal-alignment'
          }
        >
          <div
            className={
              customClassJustifycenter
                ? 'mui-custom-form pl-3'
                : 'mui-custom-form'
            }
          >
            <div className={removeClassName ? '' : 'text-left'}>
              {childrenComponent}
            </div>
          </div>
        </div>
      </DialogContent>
      {viewAction && (
        <DialogActions
          className={
            customClassJustifycenter ? 'justify-center' : 'justify-end'
          }
        >
          <div className="float-right">
            <div className="btn-wrapper my-2 mx-auto">
              <div className="float-right hide-on-print">
                {calculateTitle && (
                  <Button
                    onClick={onCalculate}
                    className="btn btn-success btn-search mr-2"
                    data-testid="filter-search-add-ndc-modal-add-btn"
                    disabled={isDisabledCalculate}
                  >
                    <SVGComponent iconName="Icon_awesome-check-circle" />
                    {calculateTitle}
                  </Button>
                )}
                {okTitle && (
                  <Button
                    onClick={onOk}
                    className="btn btn-success btn-search mr-2"
                    disabled={disableOk || false}
                    data-testid="filter-search-add-ndc-modal-add-btn"
                  >
                    <SVGComponent iconName="Icon_awesome-check-circle" />
                    {okTitle}
                  </Button>
                )}
                {noTitle && (
                  <Button
                    onClick={onNo}
                    className="btn btn-success btn-search mr-2"
                    disabled={disableNo || false}
                  >
                    <SVGComponent iconName="Icon-cancel" />
                    {noTitle}
                  </Button>
                )}
                {closeTitle && (
                  <Button
                    onClick={() => onClose('button')}
                    className="btn btn-cancel btn-primary mr-2"
                    data-testid="filter-search-add-ndc-modal-cancel-btn"
                    color="primary"
                    autoFocus={!autoFocus}
                  >
                    <SVGComponent iconName="Icon-cancel" />
                    {closeTitle}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default CommonModal;
